import { createAction } from '@reduxjs/toolkit';

export const setSearchFilter = createAction('projectSearch/setSearchFilter');

export const setShortTermProjectSearchFilterValue = createAction(
  'projects/setShortTermProjectsSeachFilterValue'
);

export const setProjectActivityFromDate = createAction(
  'projects/setProjectActivityFromDate'
);

export const setProjectActivityToDate = createAction(
  'projects/setProjectActivityToDate'
);

export const setSelectedStatusBasedProjectsMode = createAction(
  'projects/setSelectedStatusBasedProjectsMode'
);
